import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { forEach } from '@angular/router/src/utils/collection';

import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service'

declare var $: any;
declare var videojs: any;
declare var chromecastPlayer: any;
@Component({
  selector: 'app-player2',
  templateUrl: './player2.component.html',
  styleUrls: ['./player2.component.css']
})

export class Player2Component {
  constructor(private router: Router, private auth: AuthService) { }

  ngAfterViewInit() {
    $('app-header').html("");
    $('app-header').css("background-color", "rgb(41, 116, 176)");
    this.auth.video('https://wowzaprod237-i.akamaihd.net/hls/live/1020337/0a694ff6/playlist.m3u8').subscribe((resp) => {
      this.initPlayer(resp['response']['video']['src']);
    }, (err) => {
    });
  }

  initPlayer(video, err = false) {

    videojs.options.hls.overrideNative = true;
    videojs.options.html5.nativeAudioTracks = false;
    videojs.options.html5.nativeTextTracks = false;

    chromecastPlayer = videojs('player_one');

    chromecastPlayer.nuevo({
      // plugin option1, plugin option2, plugin option3
    });

    chromecastPlayer.src({// video test: https://storage.googleapis.com/shaka-demo-assets/angel-one-hls/hls.m3u8
      type: 'application/x-mpegURL',
      src: video,
      withCredentials: true
    });
    chromecastPlayer.chromecast({ metatitle: "Chromecast demo", metasubtitle: "Have fun casting your videos!" });
    if (!err || video !== "") {
      chromecastPlayer.errors({
        errors: {
          1: {
            headline: 'Error video abortado',
            message: 'Ha ocurrido un error al cargar el video'
          },
          2: {
            headline: 'Error de conexión',
            message: 'Ha ocurrido un error con la conexión.'
          },
          3: {
            headline: 'Error de decodificación',
            message: 'Ha ocurrido un error con la decodificación del video'
          },
          4: {
            headline: 'Error de formato de video',
            message: 'Ha ocurrido un error con el formato del video'
          },
          5: {
            headline: 'Error de encriptacion',
            message: 'Ha ocurrido un error con la encriptacion del video'
          },
          '-1': {
            headline: 'Error en src',
            message: 'Ha ocurrido un error con el origen del video'
          },
          '-2': {
            headline: 'Error de tiempo de espera',
            message: 'Ha ocurrido un error al cargar el video'
          },
          'unknown': {
            headline: 'Error desconocido',
            message: 'Ha ocurrido un error desconocido'
          }
        }
      });
    } else {

      chromecastPlayer.errors();
      chromecastPlayer.errors.timeout(5 * 1000);
      chromecastPlayer.errors.extend({
        PLAYER_ERR_FOO: {
          headline: 'Enlace no encontrado',
          message: 'El video no fue encontrado, por favor intente mas tarde.'
        }
      });
      chromecastPlayer.error({ code: 'PLAYER_ERR_FOO' });
    }

  }


}